import { RodRequestFilterByTerm, RodRequestSortByTerm, SortOrder } from '@bechtel/types';
import { t } from '@lingui/macro';
import { PickupTimeTerm, RodRequestDrawerValuesProps } from './types';

export const drawerValues: RodRequestDrawerValuesProps = {
  searchByList: [RodRequestFilterByTerm.WELDER],
  sortBy: RodRequestSortByTerm.REQUEST_TIME,
  sortDir: SortOrder.DESC,
  pickupTimeList: [],
};

export const searchByList = [
  { label: t`Welders`, value: RodRequestFilterByTerm.WELDER },
  { label: t`Weld ID`, value: RodRequestFilterByTerm.WELD_TAG },
  { label: t`Requester`, value: RodRequestFilterByTerm.REQUESTER },
  { label: t`Rod Request ID`, value: RodRequestFilterByTerm.ROD_REQUEST_NUMBER },
  { label: t`Rod Container`, value: RodRequestFilterByTerm.ROD_CONTAINER },
];

export const sortByList = [
  { label: t`Request Time`, value: RodRequestSortByTerm.REQUEST_TIME },
  { label: t`Request ID`, value: RodRequestSortByTerm.REQUEST_NUMBER },
];

export const pickupTimeList = [
  { label: t`Today`, value: PickupTimeTerm.TODAY },
  { label: t`Tomorrow`, value: PickupTimeTerm.TOMORROW },
  { label: t`Past Days`, value: PickupTimeTerm.PAST_DAYS },
];
